<app-filter-header title="Filtrar motius desestimació" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-filter-text-edit id="grua-motius-desestimar-filter-motiu" class="col-sm-11" i18n-label label="Motiu" [(value)]="filter.motiu" contains></app-filter-text-edit>
  </div>
</div>
